var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDesconto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5BF89648-4691-4B86-9E11-902EB7D85579") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maio---indique-um-amigo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indique-v2-1",
    transform: "translate(-688.000000, -885.000000)",
    fill: "#FF6A58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-desconto",
    transform: "translate(688.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0.333333333 C16.5128358,0.333333333 16.9355072,0.719373524 16.9932723,1.21671221 L17,1.33333333 L17,30.6666667 C17,31.2189514 16.5522847,31.6666667 16,31.6666667 C15.4871642,31.6666667 15.0644928,31.2806265 15.0067277,30.7832878 L15,30.6666667 L15,1.33333333 C15,0.781048584 15.4477153,0.333333333 16,0.333333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6666667,5.66666667 C23.2189514,5.66666667 23.6666667,6.11438192 23.6666667,6.66666667 C23.6666667,7.17950251 23.2806265,7.60217383 22.7832878,7.65993894 L22.6666667,7.66666667 L12.6666667,7.66666667 C10.6416226,7.66666667 9,9.30828925 9,11.3333333 C9,13.2930534 10.5374197,14.8936899 12.4719338,14.9949175 L12.6666667,15 L19.3333334,15 C22.4629469,15.0000001 25,17.5370531 25,20.6666667 C25,23.7234985 22.5795772,26.2150104 19.5506926,26.3292414 L19.3333333,26.3333333 L8,26.3333333 C7.44771525,26.3333333 7,25.8856181 7,25.3333333 C7,24.8204975 7.38604019,24.3978262 7.88337887,24.3400611 L8,24.3333333 L19.3333333,24.3333333 C21.3583774,24.3333333 23,22.6917107 23,20.6666667 C23,18.7069466 21.4625803,17.1063102 19.5280662,17.0050825 L19.3333333,17 L12.6666667,17 C9.53705308,17 7,14.4629469 7,11.3333333 C7,8.27650146 9.42042274,5.78498961 12.4493074,5.67075857 L12.6666667,5.66666667 L22.6666667,5.66666667 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDesconto);
export default __webpack_public_path__ + "static/media/ic-desconto.ef649336ad4e397fc5a78aa2ae30d023.svg";
export { ForwardRef as ReactComponent };